interface ButtonLinkProps {
	isOnboarding?: boolean;
	overrrideText?: string;
}

export const ButtonLink: React.FC<ButtonLinkProps> = ({
	isOnboarding = false,
	overrrideText = null,
}) => {
	return (
		<td
			style={{
				backgroundColor: isOnboarding ? "#263859" : "#003CE9",
				borderRadius: "4px",
				textAlign: "center",
			}}
			width="100%"
		>
			<div
				style={{
					display: "inline-block",
					padding: "12px 24px",
					color: "#ffffff",
					fontFamily: "Arial, sans-serif",
					fontSize: "16px",
					textDecoration: "none",
					textAlign: "center",
				}}
			>
				View{overrrideText ? ` ${overrrideText}` : ""} in Procuracon
			</div>
		</td>
	);
};
